// @flow
import hasPermission from '../globalFunctions/hasPermission';

export default {
  path: 'visita/powerbi',
  component: () => import('modules/powerbi/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Dashboards',
            name: 'IconListVisitDash'
          }
        ]
      },
      name: 'IconListVisitDash',
      component: () => import('modules/powerbi/IconListVisitDash.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.visita.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'visitas',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Dashboards',
            name: 'IconListVisitDash'
          },
          {
            text: 'Visitas',
            name: 'DashVisit'
          }
        ]
      },
      name: 'DashVisit',
      component: () => import('modules/powerbi/Visit.vue'),
      // eslint-disable-next-line
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.visita.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'checklist',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Dashboards',
            name: 'IconListVisitDash'
          },
          {
            text: 'checklist',
            name: 'Checklist'
          }
        ]
      },
      name: 'Checklist',
      component: () => import('modules/powerbi/Checklist.vue'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.visita.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'planos-acao',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Dashboards',
            name: 'IconListVisitDash'
          },
          {
            text: 'Planos de Ação',
            name: 'PlanoAcao'
          }
        ]
      },
      name: 'PlanoAcao',
      component: () => import('modules/powerbi/PlanosAcao'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.visita.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    },
    {
      path: 'painel-gerencial',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Dashboards',
            name: 'IconListVisitDash'
          },
          {
            text: 'Painel Gerencial',
            name: 'PainelGerencial'
          }
        ]
      },
      name: 'PainelGerencial',
      component: () => import('modules/powerbi/PainelGerencial'),
      beforeEnter: (to, from, next) => {
        if (hasPermission('web.powerbi.visita.acesso')) {
          next();
        } else {
          next('/');
        }
      }
    }
  ]
};
